import { useLayoutEffect, useRef, useState, useEffect } from "react";

const useEnhancedEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

/** Measure on DOM element on resize */
export function useMeasure() {
  const divRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEnhancedEffect(() => {
    const observer = new ResizeObserver((entries) => {
      setDimensions(entries[0]!.contentRect);
    });

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => observer.disconnect();
  }, [setDimensions]);

  return [divRef, dimensions] as const;
}
